<template>
  <div class="page-about">
    <div class="container">
      <div class="title_holder">
        <h3>{{$t("nav.about_us")}}</h3>
        <div class="breadcrumbs">
          <ul>
            <li class="item-home">
              <router-link class="bread-link bread-home" :to="`/${locale}`" title="Home"
                >{{$t("nav.main")}}</router-link
              >
            </li>
            <li class="separator separator-home">
              <span></span>
            </li>
            <li class="item-current">
              <span class="bread-current">{{$t("nav.about_us")}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="container">
      <div class="block-desc">
        <div class="row">
          <div class="col-md-7">
            <div class="title_holder">
              <h3 class="title">{{$t("main_page.title")}}</h3>
              <div class="desc" v-html="getDesc">
              </div>
            </div>
            <!--<div class="sign_holder">
                <img src="../assets/images/about-sign.png" alt>
                <h3 class="name">Имя Фамилия</h3>
                <p class="occ">Исполнительный директор</p>
            </div>-->
          </div>
          <div class="col-md-5">
            <p class="text-center as-mini-title">
              <span>{{ $t("main_page.qualitatively") }}</span>
            </p>
            <parallax-container class="as-paralax">
              <parallax-element
                class="paralax-block"
                :parallaxStrength="-30"
                :type="'translation'"
              ></parallax-element>
              <parallax-element
                class="paralax-image"
                :parallaxStrength="-60"
                :type="'translation'"
              ></parallax-element>
            </parallax-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    getDesc() {
      return this.$i18n.messages[this.$i18n.locale].main_page.description;
    }
  },
  data() {
    return {
      locale: this.$route.params.locale
    }
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
      this.showFilter = false;
      this.priceSlider.value = [null, null];
    }
  }
};
</script>
<style>
.page-about .block-about2 {
  box-shadow: 10px 0px 40px rgba(0, 0, 0, 0.08);
  background-color: #081225;
  padding: 50px 70px 50px 80px;
  color: #fff;
  margin-bottom: 57px;
}
.page-about .info-text {
  margin-bottom: 57px;
}
.page-about .info-text p {
  letter-spacing: 1px;
  line-height: 1.8;
  color: #666666;
  font-size: 18px;
  font-weight: 300;
}
.page-about .block-about2 .block-desc h3 {
  margin: 0px;
  padding: 0px;
  font-size: 36px;
  letter-spacing: 0px;
  font-weight: 500;
  margin-bottom: 37px;
  color: #fff;
  line-height: 1;
  position: relative;
  left: -2px;
}
.page-about .block-about2 .block-desc h3:after {
  content: "";
  top: 100%;
  left: 2px;
  position: absolute;
  width: 100px;
  height: 2px;
  background-color: #45a2df;
  margin-top: 14px;
}
.page-about .block-about2 .badge_holder {
  width: 100%;
  border: 10px solid #ad3110;
  padding: 16px 20px 10px 20px;
  min-height: 240px;
  max-width: 240px;
  min-width: 240px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.page-about .block-about2 .badge_holder .content {
  float: left;
  width: 100%;
  clear: both;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.page-about .block-about2 .badge_holder .content .year {
  font-size: 72px;
  letter-spacing: -1px;
  margin: 0px;
  line-height: 1;
  font-weight: 400;
}
.page-about .block-about2 .badge_holder .content span:not(.year) {
  color: #ad3110;
  margin-left: 5px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}
.as-counter {
  position: relative;
  z-index: 100;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.as-counter li div {
  margin-bottom: 37px;
}
.as-counter li h3 {
  margin: 0px;
  padding: 0px;
  font-size: 48px;
  font-weight: 500;
  letter-spacing: 0px;
  color: #eee;
  line-height: 1;
  margin-bottom: 2px;
}
.as-counter p {
  color: #ccc;
}
img {
  width: 100%;
}
.page-about .block-desc {
  margin-top: 30px;
  margin-bottom: 30px;
}
.page-about .block-about {
  padding-top: 70px;
  padding-bottom: 121px;
  position: relative;
  overflow: hidden;
  margin-top: 70px;
  margin-bottom: 70px;
}
.page-about .block-about:after {
  content: "";
  position: absolute;
  background-color: #081225;
  z-index: 4;
  transform: rotate(15deg);
  top: -800px;
  bottom: -800px;
  left: -800px;
  right: 55%;
}
.page-about .about-overlay {
  background-image: url("../assets/images/cwr-bg.jpg");
  background-position: bottom left;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 3;
}
.page-about .inner {
  width: 100%;
  float: left;
  clear: both;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.page-about .rightpart {
  padding: 87px 190px 80px 100px;
  position: relative;
  background-color: #fff;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  z-index: 100;
  float: left;
  width: 100%;
}
.page-about .rightpart:before {
  content: "";
  border-top: 20px solid transparent;
  border-right: 30px solid #d24e1a;
  position: absolute;
  top: 40px;
  right: 0px;
  z-index: 7;
}
.page-about .rightpart:after {
  content: "";
  position: absolute;
  z-index: 5;
  right: 0px;
  bottom: 0px;
  width: 30px;
  top: 60px;
  background-color: #d24e1a;
  border-bottom-right-radius: 5px;
}
.page-about .rightpart .rating_holder {
  position: absolute;
  z-index: 25;
  width: 80px;
  right: 80px;
  top: 0px;
  padding: 6px 13px 26px 13px;
  text-align: center;
  color: #fff;
  transition: all 0.3s ease;
  background: transparent;
}
.page-about .rightpart .rating_holder:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 15px;
  z-index: -1;
  background-color: #d24e1a;
}
.page-about .rightpart .r_footer:before {
  position: absolute;
  bottom: 0px;
  right: 0px;
  content: "";
  border-top: 15px solid #d24e1a;
  border-left: 40px solid transparent;
}
.page-about .rightpart .r_footer:after {
  position: absolute;
  bottom: 0px;
  left: 0px;
  content: "";
  border-top: 15px solid #d24e1a;
  border-right: 40px solid transparent;
}
.page-about .rightpart .rating_holder > a {
  position: absolute;
  display: block;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 10;
}
.page-about .rightpart .rating_holder img,
.page-about .rightpart .rating_holder svg {
  width: 36px;
  height: 36px;
  position: relative;
}
.page-about .rightpart .rating_holder h3.rating_number {
  margin: 0px;
  padding: 0px;
  font-size: 24px;
  letter-spacing: -0.25px;
  font-weight: 700;
  color: #fff;
  position: relative;
  margin-top: -7px;
  margin-bottom: 5px;
}
.page-about .rightpart .rating_holder h3.rating_text {
  margin: 0px;
  padding: 0px;
  font-size: 10px;
  line-height: 14px;
  text-transform: uppercase;
  letter-spacing: 0px;
  font-weight: 400;
  color: #fff;
}
.page-about .rightpart .content_holder {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  z-index: 20;
}
.page-about .rightpart .content_holder h5 {
  margin: 0px;
  padding: 0px;
  font-weight: 400;
  font-size: 20px;
  letter-spacing: 0px;
  line-height: 1;
  color: #041230;
  margin-bottom: 7px;
}
.page-about .rightpart .content_holder h3 {
  margin: 0px;
  padding: 0px;
  font-weight: 500;
  font-size: 36px;
  letter-spacing: 0px;
  color: #041230;
  line-height: 1;
  margin-bottom: 38px;
  position: relative;
  left: -2px;
}
.page-about .rightpart .content_holder h3:after {
  content: "";
  position: absolute;
  width: 100px;
  height: 2px;
  background-color: #d24e1a;
  top: 100%;
  left: 2px;
  margin-top: 14px;
}
.page-about .rightpart .content_holder p {
  margin: 0px;
  padding: 0px;
  margin-bottom: 35px;
  color: #666;
}
.page-about .rightpart .img_list {
  width: 100%;
  float: left;
  clear: both;
}
.page-about .rightpart ul {
  list-style-type: none;
  margin: 0px;
  margin-left: -10px;
  padding: 0;
}
.page-about .rightpart li {
  float: left;
  padding-left: 10px;
  margin-bottom: 10px;
  width: 160px;
  height: 90px;
}
.page-about .rightpart li div {
  width: 150px;
  height: 90px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  position: absolute;
  background-color: #eee;
  cursor: pointer;
  border-radius: 5px;
  overflow: hidden;
}
.page-about .title_holder {
  position: relative;
  padding: 95px 0 35px;
  width: 100%;
  float: left;
  clear: both;
}
.block-desc .title_holder {
  padding: 0 0 35px;
}
.page-about .title_holder:before {
  bottom: 13px;
  width: 150px;
  border-radius: 10px;
}
.page-about .title_holder:after {
  bottom: 0;
  width: 70px;
  border-radius: 10px;
}
.page-about .title_holder:before,
.page-about .title_holder:after {
  left: 0;
  position: absolute;
  height: 6px;
  background-color: #eee;
  content: "";
}
.page-about .title_holder .breadcrumbs {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  padding-top: 13px;
  padding-bottom: 2px;
}
.page-about .title_holder .breadcrumbs ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.page-about .title_holder .breadcrumbs li {
  float: left;
  margin-bottom: 5px;
}
.page-about .title_holder .breadcrumbs li a {
  font-size: 14px;
  color: #666;
  text-decoration: none;
  letter-spacing: 0;
  line-height: 1.5;
  font-weight: 600;
}
.page-about .title_holder .breadcrumbs .separator span {
  width: 33px;
  height: 24px;
  display: block;
  position: relative;
}
.page-about .title_holder .breadcrumbs .separator span:after,
.page-about .title_holder .breadcrumbs .separator span:before {
  width: 9px;
  height: 2px;
  display: block;
  position: absolute;
  background-color: #ddd;
  left: 13px;
  content: "";
}
.page-about .title_holder .breadcrumbs .separator span:before {
  top: 14px;
  transform: rotate(135deg);
}
.page-about .title_holder .breadcrumbs .separator span:after {
  top: 8px;
  transform: rotate(45deg);
}
</style>
